import React, { Component } from 'react'
import Snackbar from '@material-ui/core/Snackbar'
import UserModel from 'src/Models/UserModel'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import { updateSubscription } from 'src/services/stripe'

import Typography from '@material-ui/core/Typography'

export default class UpdateComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      dialog: false,
      snackbar: {
        open: false,
        message: '',
      },
    }
  }

  handleSubscriptionUpdate = async () => {
    UserModel.stripeCustomer.reset()
    this.handleSubscriptionUpdateClose()

    const { subscriptionId } = this.props

    try {
      await updateSubscription(subscriptionId, this.props.planId)
      this.props.callback(subscriptionId)
    } catch (err) {
      console.error(err)
      this.setState({
        snackbar: {
          open: true,
          message:
            'There was an error updating your subscription. Please try again later.',
        },
      })
    }
  }

  handleSubscriptionUpdateOpen = () => {
    this.setState({ dialog: true })
  }

  handleSubscriptionUpdateClose = () => {
    this.setState({ dialog: false })
  }

  /**
   * Handles snackbar action button is touchtap.
   */
  handleActionClick = () => {
    this.setState({
      snackbar: {
        open: false,
        message: '',
      },
    })
  }

  render() {
    return (
      <div>
        <Typography variant="h5" style={{ marginBottom: 8 }}>
          {this.props.header}
        </Typography>
        <Button
          variant="contained"
          color="secondary"
          size="large"
          style={{ margin: '13px' }}
          onClick={this.handleSubscriptionUpdateOpen}
        >
          Switch to {this.props.header}
        </Button>
        <Snackbar
          action={
            <Button color="primary" onClick={this.handleActionClick}>
              Close
            </Button>
          }
          open={this.state.snackbar.open}
          message={this.state.snackbar.message}
          autoHideDuration={10000}
        />

        <Dialog
          onClose={this.handleSubscriptionUpdateClose}
          open={this.state.dialog}
        >
          <DialogTitle>Subscription update</DialogTitle>
          <DialogContent>
            Are you sure you want to change your subscription plan?
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleSubscriptionUpdateClose}>Close</Button>
            <Button onClick={this.handleSubscriptionUpdate} color="primary">
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}
